import { render, staticRenderFns } from "./UploadTestResult.vue?vue&type=template&id=4891958e&scoped=true"
import script from "./UploadTestResult.vue?vue&type=script&lang=js"
export * from "./UploadTestResult.vue?vue&type=script&lang=js"
import style0 from "./UploadTestResult.vue?vue&type=style&index=0&id=4891958e&prod&scoped=true&lang=css"
import style1 from "./UploadTestResult.vue?vue&type=style&index=1&id=4891958e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4891958e",
  null
  
)

export default component.exports